import React from "react";
import { toast } from "react-toastify";
import { MdContentCopy } from "react-icons/md";
import FilterSection from "./FilterSection";
import SearchBar from "./SearchBar";
import TransactionList from "./TransactionList";
import { copyTextToClipboard, primaryColor } from "../../utils/comman/Common";
import WalletDateFilter from "../../utils/comman/statusDateFilter";

import Pagination from "../../utils/Pagination";
import AddTicket from "../Model/AddTicket";

import { useSelector } from "react-redux";

const MidSection = (props) => {
  const {
    applyStatus,
    statusOption,
    changeHandler,
    selectedStatus,
    filterupdatedOn,
    setFilterupdatedOn,
    fromDateHandler,
    formDate,
    toDateHandler,
    toDate,
    checkDisable,
    resetApply,
    searched,
    searchdata,
    clearSearchData,
    bgColor,
    search,
    searchedByItemShow,
    searchedBy,
    ticketRequest,
    show,
    handleClose,
    handleShow,
    showTicketDropdown,
    selectedTicket,
    setselectedTicket,
    isAllTicketResolved,
    setIsAllTicketResolved,
    ticketLists,
    headers,
    transactionStatuswithAmount,
    isDataLoaded,
    calculateTimeDifference,
    getTodaytDateTime,
    userTimeZone,
    showMerchnat,
    checkTxnIsnotFake,
    utrLeng,
    setSearchTyping,
    searchedByItem,
    setSearchedBy,
    setSearchedByItemShow,
    selectedTraxn,
    setShowTicketDropdown,
    setTicketLists,
    sumOfallSatus,
    setStatusDateHandler,
    statusDate,
    reloadTxn,
    dataLoading,
    UILoader,
    table,
    REQID,
    TXNID,
    UTR,
    ODRCODE,
    selectedTranxtForIssue,
    handleCallBack,
    showAllData,
    searchTyping,
    statusFilterHandler,
    paginationDetails,
    onExportData,
    setpageContent,
    handalpageclick,
    dropdownOpen,
    setDropdownOpen,
    handleOpenShowAmount,
    showTotalWalletBalance,
    isDropdownOpen,
    toggleDropdown,
  } = props;
  const roles = useSelector((state) => state.authReducer?.auth?.roles);
  console.log("paginationDetails1", paginationDetails);
  return (
    <div className="mid">
      <div className="container-fluid">
        <div className="maincard">
          <div className="tab-content" id="mobiletab">
            <div
              className="tab-pane fade show active"
              id="nav-mobi"
              role="tabpanel"
              aria-labelledby="mobile-tab"
            >
              <div style={{ marginTop: "0px" }} className="head">
                <div id="search-filter-mobile-view-filter">
                  <FilterSection
                    applyStatus={applyStatus}
                    statusOption={statusOption}
                    changeHandler={changeHandler}
                    selectedStatus={selectedStatus}
                    filterupdatedOn={filterupdatedOn}
                    setFilterupdatedOn={setFilterupdatedOn}
                    fromDateHandler={fromDateHandler}
                    formDate={formDate}
                    toDateHandler={toDateHandler}
                    toDate={toDate}
                    checkDisable={checkDisable}
                    resetApply={resetApply}
                    dropdownOpen={dropdownOpen}
                    setDropdownOpen={setDropdownOpen}
                    handleOpenShowAmount={handleOpenShowAmount}
                    showTotalWalletBalance={showTotalWalletBalance}
                    isDropdownOpen={isDropdownOpen}
                    toggleDropdown={toggleDropdown}
                  />
                  <WalletDateFilter
                    transactionStatuswithAmount={transactionStatuswithAmount}
                    sumOfallSatus={sumOfallSatus}
                    setStatusDateHandler={setStatusDateHandler}
                    statusDate={statusDate}
                    reloadTxn={reloadTxn}
                    statusFilterHandler={statusFilterHandler}
                  />
                  {/* <SearchBar
                  SearchBar
                    searched={searched}
                    searchdata={searchdata}
                    clearSearchData={clearSearchData}
                    bgColor={bgColor}
                    search={search}
                    searchedByItemShow={searchedByItemShow}
                    searchedBy={searchedBy}
                    setSearchTyping={setSearchTyping}
                    searchedByItem={searchedByItem}
                    setSearchedBy={setSearchedBy}
                    setSearchedByItemShow={setSearchedByItemShow}
                    searchTyping={searchTyping}
                  /> */}
                </div>
              </div>
              <div className="txn-list" id="recntxn">
                {dataLoading ? (
                  <UILoader />
                ) : (
                  <TransactionList
                    dataLoading={dataLoading}
                    table={table}
                    isDataLoaded={isDataLoaded}
                    calculateTimeDifference={calculateTimeDifference}
                    getTodaytDateTime={getTodaytDateTime}
                    userTimeZone={userTimeZone}
                    showMerchnat={showMerchnat}
                    checkTxnIsnotFake={checkTxnIsnotFake}
                    utrLeng={utrLeng}
                    REQID={REQID}
                    TXNID={TXNID}
                    UTR={UTR}
                    ODRCODE={ODRCODE}
                    handleCallBack={handleCallBack}
                    showAllData={showAllData}
                    copyTextToClipboard={copyTextToClipboard}
                    toast={toast}
                    primaryColor={primaryColor}
                    MdContentCopy={MdContentCopy}
                    selectedTranxtForIssue={selectedTranxtForIssue}
                  />
                )}
                <div className="pager">
                  {table !== undefined &&
                    table !== null &&
                    table.length > 0 &&
                    search == "" && (
                      <p>
                        {paginationDetails.currentPage !== undefined &&
                          paginationDetails.currentPage !== null &&
                          paginationDetails.totalPost !== undefined &&
                          paginationDetails.totalPost !== null &&
                          table !== undefined &&
                          Array.isArray(table) &&
                          setpageContent(
                            paginationDetails.currentPage - 1,
                            table.length,
                            paginationDetails.totalPost
                          )}
                        {
                          <button
                            className={"lbbtn"}
                            // disabled={!isExportable}
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            // title="First select the filter than you can export"
                            type="button"
                            onClick={onExportData}
                          >
                            Export csv
                          </button>
                        }
                      </p>
                    )}

                  {paginationDetails.totalPost !== undefined &&
                    paginationDetails.totalPost !== null &&
                    paginationDetails.totalPost > 10 &&
                    search == "" && (
                      <Pagination
                        className="pagination-bar"
                        currentPage={paginationDetails.currentPage}
                        totalCount={paginationDetails.totalPost}
                        pageSize={paginationDetails.postsPerPage}
                        onPageChange={(page) => handalpageclick(page)}
                      />
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MidSection;
